import { privateRoutesPath } from "../Routes";
import history from "./history";

export const ORDER_INPROGRESS = 'In-progress';
export const ORDER_CANCELED = 'Canceled';
export const ORDER_OPEN = 'Open';

export const INVOICE_STATUS_OPEN = 'INVOICE_STATUS_OPEN';
export const INVOICE_STATUS_PAID = 'INVOICE_STATUS_PAID';
export const INVOICE_STATUS_SENT = 'INVOICE_STATUS_SENT';
export const INVOICE_STATUS_CANCELLED = 'INVOICE_STATUS_CANCELLED';
export const INVOICE_STATUS_OVERRIDE = 'INVOICE_STATUS_OVERRIDE';


 export const country = [
    { name: "Afghanistan" },
    { name: "Albania" },
    { name: "Algeria" },
    { name: "Andorra" },
    { name: "Angola" },
    { name: "Antigua and Barbuda" },
    { name: "Argentina" },
    { name: "Armenia" },
    { name: "Australia" },
    { name: "Austria" },
    { name: "Azerbaijan" },
    { name: "Bahamas" },
    { name: "Bahrain" },
    { name: "Bangladesh" },
    { name: "Barbados" },
    { name: "Belarus" },
    { name: "Belgium" },
    { name: "Belize" },
    { name: "Benin" },
    { name: "Bhutan" },
    { name: "Bolivia" },
    { name: "Bosnia and Herzegovina" },
    { name: "Botswana" },
    { name: "Brazil" },
    { name: "Brunei" },
    { name: "Bulgaria" },
    { name: "Burkina Faso" },
    { name: "Burundi" },
    { name: "Cabo Verde" },
    { name: "Cambodia" },
    { name: "Cameroon" },
    { name: "Canada" },
    { name: "Central African Republic" },
    { name: "Chad" },
    { name: "Chile" },
    { name: "China" },
    { name: "Colombia" },
    { name: "Comoros" },
    { name: "Congo (Congo-Brazzaville)" },
    { name: "Costa Rica" },
    { name: "Croatia" },
    { name: "Cuba" },
    { name: "Cyprus" },
    { name: "Czechia" },
    { name: "Democratic Republic of the Congo" },
    { name: "Denmark" },
    { name: "Djibouti" },
    { name: "Dominica" },
    { name: "Dominican Republic" },
    { name: "Ecuador" },
    { name: "Egypt" },
    { name: "El Salvador" },
    { name: "Equatorial Guinea" },
    { name: "Eritrea" },
    { name: "Estonia" },
    { name: "Eswatini" },
    { name: "Ethiopia" },
    { name: "Fiji" },
    { name: "Finland" },
    { name: "France" },
    { name: "Gabon" },
    { name: "Gambia" },
    { name: "Georgia" },
    { name: "Germany" },
    { name: "Ghana" },
    { name: "Greece" },
    { name: "Grenada" },
    { name: "Guatemala" },
    { name: "Guinea" },
    { name: "Guinea-Bissau" },
    { name: "Guyana" },
    { name: "Haiti" },
    { name: "Honduras" },
    { name: "Hungary" },
    { name: "Iceland" },
    { name: "India" },
    { name: "Indonesia" },
    { name: "Iran" },
    { name: "Iraq" },
    { name: "Ireland" },
    { name: "Israel" },
    { name: "Italy" },
    { name: "Jamaica" },
    { name: "Japan" },
    { name: "Jordan" },
    { name: "Kazakhstan" },
    { name: "Kenya" },
    { name: "Kiribati" },
    { name: "Kuwait" },
    { name: "Kyrgyzstan" },
    { name: "Laos" },
    { name: "Latvia" },
    { name: "Lebanon" },
    { name: "Lesotho" },
    { name: "Liberia" },
    { name: "Libya" },
    { name: "Liechtenstein" },
    { name: "Lithuania" },
    { name: "Luxembourg" },
    { name: "Madagascar" },
    { name: "Malawi" },
    { name: "Malaysia" },
    { name: "Maldives" },
    { name: "Mali" },
    { name: "Malta" },
    { name: "Marshall Islands" },
    { name: "Mauritania" },
    { name: "Mauritius" },
    { name: "Mexico" },
    { name: "Micronesia" },
    { name: "Moldova" },
    { name: "Monaco" },
    { name: "Mongolia" },
    { name: "Montenegro" },
    { name: "Morocco" },
    { name: "Mozambique" },
    { name: "Myanmar" },
    { name: "Namibia" },
    { name: "Nauru" },
    { name: "Nepal" },
    { name: "Netherlands" },
    { name: "New Zealand" },
    { name: "Nicaragua" },
    { name: "Niger" },
    { name: "Nigeria" },
    { name: "North Korea" },
    { name: "North Macedonia" },
    { name: "Norway" },
    { name: "Oman" },
    { name: "Pakistan" },
    { name: "Palau" },
    { name: "Palestine" },
    { name: "Panama" },
    { name: "Papua New Guinea" },
    { name: "Paraguay" },
    { name: "Peru" },
    { name: "Philippines" },
    { name: "Poland" },
    { name: "Portugal" },
    { name: "Qatar" },
    { name: "Romania" },
    { name: "Russia" },
    { name: "Rwanda" },
    { name: "Saint Kitts and Nevis" },
    { name: "Saint Lucia" },
    { name: "Saint Vincent and the Grenadines" },
    { name: "Samoa" },
    { name: "San Marino" },
    { name: "Sao Tome and Principe" },
    { name: "Saudi Arabia" },
    { name: "Senegal" },
    { name: "Serbia" },
    { name: "Seychelles" },
    { name: "Sierra Leone" },
    { name: "Singapore" },
    { name: "Slovakia" },
    { name: "Slovenia" },
    { name: "Solomon Islands" },
    { name: "Somalia" },
    { name: "South Africa" },
    { name: "South Korea" },
    { name: "South Sudan" },
    { name: "Spain" },
    { name: "Sri Lanka" },
    { name: "Sudan" },
    { name: "Suriname" },
    { name: "Sweden" },
    { name: "Switzerland" },
    { name: "Syria" },
    { name: "Taiwan" },
    { name: "Tajikistan" },
    { name: "Tanzania" },
    { name: "Thailand" },
    { name: "Timor-Leste" },
    { name: "Togo" },
    { name: "Tonga" },
    { name: "Trinidad and Tobago" },
    { name: "Tunisia" },
    { name: "Turkey" },
    { name: "Turkmenistan" },
    { name: "Tuvalu" },
    { name: "Uganda" },
    { name: "Ukraine" },
    { name: "United Arab Emirates" },
    { name: "United Kingdom" },
    { name: "United States" },
    { name: "Uruguay" },
    { name: "Uzbekistan" },
    { name: "Vanuatu" },
    { name: "Vatican City" },
    { name: "Venezuela" },
    { name: "Vietnam" },
    { name: "Yemen" },
    { name: "Zambia" },
    { name: "Zimbabwe" }
  ];
  
  export const indianStates = [
    { name: "Other" },
    { name: "Andhra Pradesh" },
    { name: "Arunachal Pradesh" },
    { name: "Assam" },
    { name: "Bihar" },
    { name: "Chhattisgarh" },
    { name: "Goa" },
    { name: "Gujarat" },
    { name: "Haryana" },
    { name: "Himachal Pradesh" },
    { name: "Jharkhand" },
    { name: "Karnataka" },
    { name: "Kerala" },
    { name: "Madhya Pradesh" },
    { name: "Maharashtra" },
    { name: "Manipur" },
    { name: "Meghalaya" },
    { name: "Mizoram" },
    { name: "Nagaland" },
    { name: "Odisha" },
    { name: "Punjab" },
    { name: "Rajasthan" },
    { name: "Sikkim" },
    { name: "Tamil Nadu" },
    { name: "Telangana" },
    { name: "Tripura" },
    { name: "Uttar Pradesh" },
    { name: "Uttarakhand" },
    { name: "West Bengal" },
    { name: "Andaman and Nicobar Islands" },
    { name: "Chandigarh" },
    { name: "Dadra and Nagar Haveli and Daman and Diu" },
    { name: "Delhi" },
    { name: "Jammu and Kashmir" },
    { name: "Ladakh" },
    { name: "Lakshadweep" },
    { name: "Puducherry" }
  ];
  
  

  export const lead_customer_income = [
    {
        label: "Low",
    },
    {
        label: "Medium",
    },
    {
        label: "High",
    }
]


export const invoice_status = [
    {
        label: "created",
    },
    {
        label: "pdf-generated",
    },
    {
        label: "paid",
    }
]

export const salesOrderStatus = {
    SO_STATUS_OPEN:"SO_STATUS_OPEN",
    SO_STATUS_PARTIALLY_INVOICED:"SO_STATUS_PARTIALLY_INVOICED",
    SO_STATUS_COMPLETELY_INVOICED:"SO_STATUS_COMPLETELY_INVOICED",
    SO_STATUS_CANCELLED:"SO_STATUS_CANCELLED",
    SALES_ORDER_STATUS_OVERRIDE:"SALES_ORDER_STATUS_OVERRIDE"
}

export const permissionList = {
    DASHBOARD_VIEW: "lms_dashboard_view",
    MERCHANT_VIEW: "lms_vendor_view",
    PRODUCT_VIEW: "lms_product_view",
    LEAD_VIEW: "lms_lead_view",
    ORDER_VIEW: "lms_salesorder_view",
    INVOICE_VIEW: "lms_invoice_view",
    DASHBOARD_MANAGE: "lms_dashboard_manage",
    MERCHANT_MANAGE: "lms_vendor_manage",
    PRODUCT_MANAGE: "lms_product_manage",
    ALL_LEAD_MANAGE: "lms_all_lead_manage",
    LEAD_MANAGE: "lms_lead_manage",
    ORDER_MANAGE: "lms_salesorder_manage",
    ALL_ORDER_MANAGE : "lms_all_sales_order_manage",
    ALL_INVOICE_MANAGE : "lms_all_invoice_manage",
    INVOICE_MANAGE: "lms_invoice_manage",
    CUSTOMER_MANAGE: "lms_customer_manage",
    CUSTOMER_VIEW: "lms_customer_view",
    CONFIGURATION_MANAGE: "lms_configuration_manage",
    CONFIGURATION_VIEW: "lms_configuration_view",
    NOTIFICATION_MANAGE: "lms_notification_manage",
    NOTIFICATION_VIEW: "lms_notification_view",
    TEMPLATE_VIEW: "lms_template_view",
    TEMPLATE_MANAGE: "lms_template_manage",
    AUDIT_VIEW: "lms_auditlogs_manage",
    AUDIT_MANAGE: "lms_auditlogs_manage",
    LEAD_TEAM_MANAGE : "lms_myteam_lead_manage",
    ORDER_TEAM_MANAGE :"lms_myteam_sales_order_manage",
    INVOICE_TEAM_MANAGE : "lms_myteam_invoice_manage"
}

export const teampermissionList = ["lms_all_lead_manage","lms_all_sales_order_manage","lms_all_invoice_manage", "lms_myteam_lead_manage", "lms_myteam_sales_order_manage", "lms_myteam_invoice_manage"]

export const myTeampermission = ["lms_myteam_lead_manage", "lms_myteam_sales_order_manage", "lms_myteam_invoice_manage"];

export const defaultmenuLabel = {
    "lead": "Lead",
    "customer": "Customer",
    "order": "Order",
    "invoice": "Invoice",
    "product": "Product",
    "merchant": "Merchant",
    "dashboard": "Dashboard",
    "campaign": "Notification",
    "template": "Template",
    "companyDetails": {
        name: "A1 Business",
        code: "ABC"
    }

}

export const OrganizationmenuLabel = {
    "lead": "Lead Test",
    "customer": "Customer Test",
    "order": "Order Test",
    "invoice": "Invoice Test",
    "product": "Product Test",
    "merchant": "Merchant Test",
    "dashboard": "Dashboard Test",
    "template": "Template",
    "campaign": "Notification",
    "companyDetails": {
        name: "A1 Test Business",
        code: "ABCTEST"
    }
}

export const notificationGroupTemplate = [
    {
        name: "Lead",
        value: "lead"
    },
    {
        name: "Customer",
        value: "customer"
    },
    {
        name: "Owner",
        value: "owner"
    },
    
]

export const dyanmicConstantAttribute = [
    {
        label: "Customer Name",
        value: "lms_customer_name"
    },
    {
        label: "Product Name",
        value: "lms_product_name"
    },
    {
        label: "Product Size",
        value: "lms_product_Size"
    },
    {
        label: "Product Price",
        value: "lms_product_price"
    },
    
]


export const LEAD_STATUS = "LEAD_STATUS";
export const LEAD_STATUS_PROSPECT = "LEAD_STATUS_PROSPECT";
export const LEAD_ATTRIBUTE = "LEAD_ATTRIBUTE";
export const LEAD_SOURCE = "LEAD_SOURCE";
export const LEAD_DESIRABILITY = "LEAD_DESIRABILITY";
export const LEAD_INCOME = "LEAD_INCOME";
export const CUSTOMER_STATUS = "CUSTOMER_STATUS";
export const CUSTOMER_SOURCE = "CUSTOMER_SOURCE";
export const CUSTOMER_DOC_TYPE = "CUSTOMER_DOC_TYPE";
export const VENDOR_STATUS = "VENDOR_STATUS";
export const VENDOR_DOC_TYPE = "VENDOR_DOC_TYPE";
export const CLIENT_DOC_TYPE = "CLIENT_DOC_TYPE";
export const COMMON_DOC_STATUS = "COMMON_DOC_STATUS";
export const CLIENT_DT_LOGO = "CLIENT_DT_LOGO";
export const LEAD_STATUS_DEAL_CLOSED = "LEAD_STATUS_DEAL_CLOSED";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
export const PRODUCT_UOM = "PRODUCT_UOM";
export const PRODUCT_DOC_TYPE = "PRODUCT_DOC_TYPE";
export const SALES_ORDER_STATUS = "SALES_ORDER_STATUS";
export const INVOICE_STATUS = "INVOICE_STATUS";
export const PRODUCT_STATUS = "PRODUCT_STATUS";
export const ACTIVE_STATUS = "ACTIVE";
export const TEMPLATE_CHANNEL = "TEMPLATE_CHANNEL";
export const TEMPLATE_STATUS = "TEMPLATE_STATUS";
export const TEMPLATE_TYPE = "TEMPLATE_TYPE";

export const allowedLogoTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const allowedOtherTypes = [
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "text/csv", // .csv
  "image/jpeg",
  "image/jpg",
  "image/png"
];

export const lookuprecorddata = [
    {
        lookuptypename: "LEAD_STATUS",
        systemlookupcode: "Open, Closed, inprogress",
        id: 1
    },
    {
        lookuptypename: "LEAD_ATTRIBUTE",
        systemlookupcode: "cold, warm, hot",
        id: 2
    },
    {
        lookuptypename: "LEAD_INCOME",
        systemlookupcode: "High, Low",
        id: 3
    },
   

]


export const leadStaticData = {
    "LEAD_PHONE_NUMBER": "Phone Number",
    "LEAD_EMAIL": "Email",
    "LEAD_OWNER": "Owner",
    "LEAD_SALE_COMMISION": "Sale Commision(%)",
    "LEAD_FOLLOWUP_NOTE": "Note",
    "LEAD_NEXT_FOLLOWUP_DATE": "Next follow up",
    "LEAD_INTERESTED_PRODUCT": "Interested in products",
    "LEAD_ALREDAY_A_CUSTOMER": "Already a customer",
    "LEAD_FOLLOWUP": "Lead followup",
    "LEAD_DOCUMENT": "Lead document",
    "LEAD_CREATE_COPY_LEAD": "Create copy lead",
    "LEAD_CANCEL":"cancel this lead",
    "LEAD_REASSIGN": "Lead Re-assign",
    "LEAD_SELECTED_CANCEL": "cancel Selected Lead",
    "LEAD_CREATE_LEAD": "Create lead",
    "LEAD_BULK_UPLOAD": "Bulk Upload",
    "LEAD_LEAD_SEARCH": "Lead Search",
    "LEAD_NAME": "Name",
    "LEAD_CREATED_FROM": "Created from",
    "LEAD_CREATED_TO": "Created to",
    "LEAD_UPDATED_FROM": "Updated from",
    "LEAD_CREATED_AT": "Created at",
    "LEAD_UPDATED_AT": "Updated at",
    "LEAD_ACTIONS": "Actions",
    "LEAD_BACK": "Back",
    "LEAD_SAVE": "Save",
    "LEAD_UPDATE": "Update",
    "LEAD_SELECT_TEMPLATE": "Select Template",
    "LEAD_SELECT_FILE": "Select File",
    "LEAD_UPLOAD": "Upload",
    "LEAD_CREATE_NEW_TEMPLATE": "Create new template",
    "LEAD_PROCESS_SELECTED_FILE": "Process selected file",
    "LEAD_PRODUCT_TYPE": "Type",
    "LEAD_PRODUCT_PRICE_FROM": "Price from",
    "LEAD_PRODUCT_PRICE_TO": "Price to",
    "LEAD_PRODUCT_PRODUCT": "Product",
    "LEAD_PRODUCT_ADD": "Add",
    "LEAD_UPDATED_TO": "Updated To",
    "LEAD_SOURCE":"Source",
    "LEAD_STATUS": "Status",
    "LEAD_RESET":"Reset",
    "LEAD_INCOME_GROUP": "Income Group",
    "LEAD_ATTRIBUTE": "Attribute value",
    "LEAD_CANCEL_CONFIRMATION": "Are you sure want to cancel this Lead ?",
    "LEAD_CANCEL_DIALOG_TITLE": "Cancel Lead",
    "LEAD_DEAL_CLOSED_DIALOG_TITLE": "Deal Closed Confirmation",
    "LEAD_DEAL_CLOSED_DIALOG_DESCRIPTION": "  Check the final products sold in this deal. To edit the product qty or price, please update it in the lead first and then close the deal",
    "LEAD_DEAL_CLOSE_BUTTON": "Close The Deal",
    "LEAD_FINAL_DEAL_CLOSE_DIALOG_TITLE": "Deal Closed Final Confirmation",
    "LEAD_FINAL_DEAL_CLOSE_DESCRIPTION": "  Are you sure to close the deal with this lead?",
    "LEAD_BULK_UPLOAD_FINISHED_TEXT": " Bulk Upload finished. Download the processed file to review the errors, if any then submit again.",
    "LEAD_BULK_UPLOAD_FILE_COLUMN":"File Columns",
    "LEAD_LEAD": "Lead",
    "LEAD_BULK_UPLOAD_DB_COLUMN":" DB Columns",
    "DASHBOARD_SIDEBAR_MENU": "Dashboard",
    "CUSTOMER_SIDEBAR_MENU": "Customer",
    "MERCHANT_SIDEBAR_MENU": "Merchant",
    "PRODUCT_SIDEBAR_MENU": "Product",
    "ORDER_SIDEBAR_MENU": "Order",
    "INVOICE_SIDEBAR_MENU": "Invoice",
    "NOTIFICATION_SIDEBAR_MENU": "Notification",
    "CONFIGURATION_SIDEBAR_MENU": "Configurations",
    "TEMPLATE_SIDEBAR_MENU": "Template",
    "LEAD_SIDEBAR_MENU": "Lead"


}

export const customerAgeGroup = [
    {name : "15 to 20"},
    { name : "21 to 30"},
    { name : "30 to 50"},  
]


export const handleValidateCodevalue = (storedata, code) => {
    
        return storedata?.hasOwnProperty(code) ? storedata?.[code] : code;
}

export const auditEntity = [
    {
        name: "LEAD_SIDEBAR_MENU",
        id: "LEAD_SIDEBAR_MENU" 
    },
    {
        name: "CUSTOMER_SIDEBAR_MENU",
        id: "CUSTOMER_SIDEBAR_MENU" 
    },
    {
        name: "MERCHANT_SIDEBAR_MENU",
        id: "MERCHANT_SIDEBAR_MENU" 
    },
    {
        name: "PRODUCT_SIDEBAR_MENU",
        id: "PRODUCT_SIDEBAR_MENU" 
    },
    {
        name: "ORDER_SIDEBAR_MENU",
        id: "ORDER_SIDEBAR_MENU" 
    },
    {
        name: "INVOICE_SIDEBAR_MENU",
        id: "INVOICE_SIDEBAR_MENU" 
    },
    {
        name: "CONFIGURATION_USER_MENU",
        id: "CONFIGURATION_USER_MENU" 
    },
    {
        name: "CONFIGURATION_CLIENT_MENU",
        id: "CONFIGURATION_CLIENT_MENU" 
    },
    {
        name: "TEMPLATE_SIDEBAR_MENU",
        id: "TEMPLATE_SIDEBAR_MENU"
    }

]

export const entitylist = {
    "Lead": "Lead",
    "LeadProduct": "Lead",
    "LeadFollowup": "Lead",
    "Customer": "Customer",
    "Product": "Product",
    "SalesOrderProduct": "SalesOrder",
    "SalesOrder": "SalesOrder",
    "Client": "Client",
    "User": "User",
    "UserRole": "User",
    "Vendor": "Vendor",
    "Invoice": "Invoice",
    "InvoiceProduct": "Invoice",
    "Template": "Template"

}

export const filterSelection = [
    {
        name: "Last 7 days",
        value: ""
    },
    {
        name: "Last 15 days",
        value: ""
    },
    {
        name: "Last 30 days",
        value: ""
    },
    {
        name: "Last 90 days",
        value: ""
    }
]

export const colorCode = ['#4FC8F7','#B5FCCD', '#A1E3CD', '#8DCACC', '#79B1CC', '#1434C9', '#B950CB','#E17FF1', '#F07F92', '#FFCC9C'];

export const phoneWidth = 120;
export const nameWidth = 135;
export const productNameWidth=200;
export const fullNameWidth = 180;
export const emailWidth = 250;
export const idWidth = 70;
export const followupWidth = 250;
export const statusWidth = 100;
export const ownerWidth = 150;
export const whocolumnWidth = 120;
export const customerIdWidth = 120;
export const vendorIdWidth = 120;
export const productIdWidth = 100;
export const vendorNameWidth=180;
export const productTypeWidth = 180;
export const salesOrderIdWidth = 150;
export const sellingPriceWidth = 120;
export const templateSubjectWidth = 400;
export const templateSTFtWidth = 150; // STF = System Template Flag
export const constitutionOfBusinessWidth = 200;
export const priceAfterDiscount = 160;
export const systemLookupCodeWidth = 1000;

export const  commonTitles = [
    {label:"COMMON_TITLE_MR"},
    {label:"COMMON_TITLE_MRS"},
    {label: "COMMON_TITLE_MISS"},
    {label: "COMMON_TITLE_MS"}
    ]

export const commonLCType = [
    {label:"COMMON_LC_PERSON"},
    {label:"COMMON_LC_B2B"}
]

export const commonAgeGroup = [
    {label:"COMMON_AG_15TO20"},
    {label:"COMMON_AG_21TO30"},
    {label:"COMMON_AG_31TO50"},
    {label : "COMMON_AG_ABOVE50"}
]

export const commonMaritalStatus = [
    {label:"COMMON_MS_MARRIED"},
    {label:"COMMON_MS_UNMARRIED"},
    {label:"COMMON_MS_DIVORCED"},
    {label: "COMMON_MS_WIDOWED"}
]

export const commonIncomeGroup = [
    {label:"COMMON_IG_UPTO5_LAKH"},
    {label:"COMMON_IG_5TO10_LAKH"},
    {label:"COMMON_IG_10TO20_LAKH"},
    {label:"COMMON_IG_ABOVE20_LAKH"}
]
export const CLIENT_ACTIVITY_METRICS = [
  { key: "leadCount", label: "Leads", color: "#4FC8F7" },        // red
  { key: "customerCount", label: "Customers", color: "#B5FCCD" }, // blue
  { key: "productCount", label: "Products", color: "#A1E3CD" },   // green
  { key: "taskCount", label: "Tasks", color: "#8DCACC" },     // green
  { key: "activeUserCount", label: "Active Users", color: "#B8A9E8" },  // soft blue
];
export const dateTimeISTFormatter = (value)=>{
   return new Date(value).toLocaleString(undefined, {
    timeZone: 'Asia/Kolkata'
    })
}

export const CLIENT_ACTIVITY_CHART_HEIGHT = 260; // px
export    const filterList = [
            {
                label : "COMMON_FILTER_LAST_7_DAYS",
                value : 7
            },
            {
                label : "COMMON_FILTER_LAST_15_DAYS",
                value : 15
            },
            {
                label : "COMMON_FILTER_LAST_30_DAYS",
                value : 30
            },
            {
                label : "COMMON_FILTER_LAST_90_DAYS",
                value : 90
            },
            {
                label : "COMMON_FILTER_TILL_NOW",
                value : "TILL_NOW"
            },
            
        ]